export default {
      id: "icon-way-usage",
      viewBox: "0 0 18 18",
      url: "../icon/" + "icons.svg#icon-way-usage",
      toString: function () {
        return this.url;
      }
    }